import { render } from "./leftSideBar.vue?vue&type=template&id=80dfabc0&scoped=true"
import script from "./leftSideBar.vue?vue&type=script&lang=js"
export * from "./leftSideBar.vue?vue&type=script&lang=js"

import "./leftSideBar.vue?vue&type=style&index=0&id=80dfabc0&scoped=true&lang=css"

import exportComponent from "/data/PDBcov/VueJs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80dfabc0"]])

export default __exports__